import { useEffect, useState } from 'react';
import { AuthProvider } from './auth/AuthProvider';
import { AuthPanel } from './auth/AuthPanel';
import { useAuth } from './auth/useAuth';
import { AppShell } from './layout/AppShell';
import { useAppVersionRefresh } from './pwa/useAppVersionRefresh';

export function App() {
  const appVersion = useAppVersionRefresh();
  const [refreshing, setRefreshing] = useState(false);

  return (
    <>
      {appVersion.updateAvailable && (
        <div className="app-update-banner" role="status">
          <span>New version available.</span>
          <button
            type="button"
            onClick={() => {
              setRefreshing(true);
              appVersion.refresh();
            }}
            disabled={refreshing}
          >
            {refreshing ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>
      )}
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  const [path, setPath] = useState(() => window.location.pathname);
  const isSignInRoute = path === '/signin';

  useEffect(() => {
    function handlePopState() {
      setPath(window.location.pathname);
    }

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    if (!user || !isSignInRoute) return;
    window.history.replaceState(null, '', '/');
    setPath('/');
  }, [isSignInRoute, user]);

  return isSignInRoute ? <AuthPanel /> : <AppShell />;
}
